import { render, staticRenderFns } from "./PopularOffers.vue?vue&type=template&id=6f956c3a"
import script from "./PopularOffers.vue?vue&type=script&lang=js"
export * from "./PopularOffers.vue?vue&type=script&lang=js"
import style0 from "./PopularOffers.vue?vue&type=style&index=0&id=6f956c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports